import { DeliveryType } from "../DeliveryType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const deliveryTypeNameMap: Record<DeliveryType, LocalizedString> = {
	[DeliveryType.PacketaPickup]: { [Locale.cs]: "Zásilkovna - výdejní místo" },
	[DeliveryType.PacketaCourier]: { [Locale.cs]: "Zásilkovna - doručení na adresu" },
	[DeliveryType.Personal]: { [Locale.cs]: "Osobní vyzvednutí Novakon" },
};
